import React, { useEffect, useState } from "react";
import axios from "axios";
import "../ChatHistory/ChatHistory.css"; // Optional: for custom styles
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import actions from "../../actions";
import { getAiTableData } from "../../apis";
import { useParams } from "react-router-dom";
import AiChat from ".";
import ChatHistory from "../ChatHistory/index"

const AiChatHistoryTable = () => {
  const { id } = useParams();
  const [chatHistory, setChatHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [receiverId,setReceiverId] = useState(null);
  const [viewDate,setViewDate]=useState(null);

  const fetchChatHistory = async () => {
    try {
      setLoading(true);
      const response = await getAiTableData(id);
      if (response?.data?.data) {
        setChatHistory(response.data.data);
      } else {
        setChatHistory([]);
      }
    } catch (error) {
      console.error("Error fetching chat history:", error);
      setChatHistory([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChatHistory();
  }, []);

  if (loading) return <div>Loading chat history...</div>;

  const handleViewChat = (date) => {
    setViewDate(date);
  }

  if(viewDate){
    return <AiChat date={viewDate} />;
  }

  return (
    <div className="chat-history-table-container">
      <h2  style={{paddingBottom: "20px"}}>Chat History</h2>
      <table className="chat-history-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {chatHistory.map((chat, index) => (
            <tr key={index}>
              <td>{new Date(chat.date).toLocaleDateString()}</td>
              <td>
                <button
                  className="view-button cursor-pointer"
                  onClick={()=>handleViewChat(chat.date)}
                >
                  View
                </button>
              </td>
            </tr>
          ))}
          {chatHistory.length === 0 && (
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }}>
                No chat history available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutRequest: actions.auth.logout,
      stopLoadingRequest: actions.loader.stopLoading,
      startLoadingRequest: actions.loader.startLoading,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(AiChatHistoryTable);
